import React from 'react'
import injectSheet from 'react-jss'
import styles from './create-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import SlideForm from '../slide-form/slide-form'
import Button from 'pobble-components/dist/button'
import { useDispatch } from 'react-redux'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { useSelector } from 'react-redux'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors'

const LinkSlideCreateDialog = ({ classes }) => {
  const dispatch = useDispatch()
  const close = () => dispatch(closeCreateSlideDialog())
  const createSlideDialog = useSelector(getCreateSlideDialog)
  const modalOpened =
    createSlideDialog.opened && createSlideDialog.type === 'Link'

  return (
    <Modal closeButton isOpen={modalOpened} requestClose={close}>
      <ModalHeader>Add a website link to your slide</ModalHeader>
      <SlideForm
        onSubmit={values => {
          dispatch(
            createSlide({
              type: 'Link',
              title: values.title,
              link_id: values.linkId,
              text: values.text,
              html_text: values.htmlText
            })
          )
            .then(close)
            .catch(errorHandler)
        }}
        footer={({ status }) => (
          <ModalFooter alignRight childrenGap>
            <Button action={close} tall simple>
              Cancel
            </Button>
            <Button pending={status === 'pending'} tall type="submit">
              Create slide
            </Button>
          </ModalFooter>
        )}
      />
    </Modal>
  )
}

export default injectSheet(styles)(LinkSlideCreateDialog)
